
import { sendPost } from '../http.js'
const api = {
	'getSummaryAPI': { // 数据汇总
        url: '/corporate/summary'
    },
    'getOrderListDetailAPI': { // 订单明细
        url: '/corporate/order_list'
    },
    'getClassListDetailAPI': { // 课程明细
        url: '/corporate/product_list'
    },
    'getPaymentListDetailAPI': { // 账单明细
        url: '/corporate/bill/detail'
    },
    'submitPaymentApplyAPI': { // 提交打款申请
        url: '/corporate/payment_apply'
    },
    'getPaymentApplyListAPI': { // 打款申请记录
        url: '/corporate/corporate_payment/list'
    },
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        mutationsName: api[key].mutationsName,
        requestFun:(params) => {
            return sendPost(api[key].url,params,api[key].method || 'post')
        }
    } 
}
export default requestFunObj
